module.exports = __webpack_public_path__ + "b4a777adecffe5a007d1d52246f05d2d.jpg";